// removed by extract-text-webpack-plugin
module.exports = {"ticketPriceBreakdown":"_36emRR7Q0FsauQMimYlc2A"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/PriceBreakdown.scss
// module id = 1458
// module chunks = 0